import Common from "./dashboard/common";
import Orders from "./dashboard/orders";
import Cooperators from "./dashboard/cooperators";
import Previsions from "./dashboard/previsions";
import Suppliers from "./dashboard/suppliers";
import Shippings from "./dashboard/shippings";
import Companies from "./dashboard/companies";
import Docks from "./dashboard/docks";
import Vehicles from "./dashboard/vehicles";
import Warnings from "./dashboard/warnings";
import Services from "./dashboard/services";
import Privileges from "./dashboard/privileges";
import Credentials from "./dashboard/credentials";
import Points from "./dashboard/points";
import CashierReports from "./dashboard/cashier-reports";
import Despesas from "./dashboard/despesas";
import Devedores from "./dashboard/devedores";
import ServiceGoals from "./dashboard/service-goals";
import DemandMetrics from "./dashboard/demand-metrics";
import RelatorioFinanceiro from "./dashboard/relatorio-financeiro";
import RelatorioEvolucaoMensal from "./dashboard/relatorio-evolucao-mensal";
import RelatorioAuditoriaFornecedor from "./dashboard/relatorio-auditoria-fornecedor";
import RelatorioPerformanceTempoDescarga from "./dashboard/relatorio-performance-tempo-descarga";
import RelatorioProdutividadePerformance from "./dashboard/relatorio-produtividade-performance";
import RelatorioDevolucao from "./dashboard/relatorio-devolucao";
import RelatorioIndicadorPerformance from "./dashboard/relatorio-indicador-performance";

const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard");

export default [
  {
    path: "/dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      ...Common,
      ...Orders,
      ...Cooperators,
      ...Previsions,
      ...Suppliers,
      ...Shippings,
      ...Companies,
      ...Docks,
      ...Vehicles,
      ...Warnings,
      ...Services,
      ...Privileges,
      ...Credentials,
      ...Points,
      ...CashierReports,
      ...Despesas,
      ...Devedores,
      ...ServiceGoals,
      ...DemandMetrics,
      ...RelatorioFinanceiro,
      ...RelatorioEvolucaoMensal,
      ...RelatorioAuditoriaFornecedor,
      ...RelatorioPerformanceTempoDescarga,
      ...RelatorioProdutividadePerformance,
      ...RelatorioDevolucao,
      ...RelatorioIndicadorPerformance,
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/dashboard.js